import axios from "axios";

/**
 * Vuex module: payments
 * Provides payment options combining fixed set with dynamic franchise options.
 */
export default {
  namespaced: true,
  state: () => ({
    options: [],
    loading: false,
    error: null,
  }),
  getters: {
    paymentOptions: (s) => s.options,
    isLoading: (s) => s.loading,
    error: (s) => s.error,
  },
  mutations: {
    SET_LOADING(s, v) { s.loading = v; },
    SET_ERROR(s, e) { s.error = e; },
    SET_OPTIONS(s, list) { s.options = list || []; },
  },
  actions: {
    /**
     * Load payment options for a given DB, merging static and dynamic.
     * @param ctx
     * @param {{DB: string}} payload
     */
    async loadPaymentOptions({ commit }, { DB }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      const staticOpts = [
        { code: "Cash", label: "Cash" },
        { code: "Card", label: "Card" },
        { code: "AccountSale", label: "Account Sale" },
        { code: "Kazang", label: "Kazang" },
        { code: "Split", label: "Split" },
      ];
      try {
        let dynamicOpts = [];
        if (DB) {
          const url = `${window.franchiseTomcatApi}payment_options/${encodeURIComponent(DB)}/getAll`;
          const { data } = await axios.get(url);
          const arr = Array.isArray(data) ? data : (data?.items || []);
          dynamicOpts = arr
            .filter((x) => x && (x.active !== false))
            .map((x) => {
              const raw = String(x.name || x.code || x.id || "").trim();
              if (!raw) return null;
              // Remove currency suffix from code e.g., "Kazang (ZMW)" -> "Kazang"
              const m = raw.match(/^(.+?)\s*\((?:[A-Za-z]{3})\)$/);
              const code = (m ? m[1] : raw).trim();
              return { code, label: raw };
            })
            .filter(Boolean);
        }
        // Merge de-duplicated by lowercased code; static wins for canonical labels
        const map = new Map(staticOpts.map((o) => [o.code.toLowerCase(), o]));
        for (const o of dynamicOpts) {
          const key = o.code.toLowerCase();
          if (!map.has(key)) map.set(key, o);
        }
        commit("SET_OPTIONS", Array.from(map.values()));
      } catch (e) {
        commit("SET_ERROR", e?.message || "Failed to load payment options");
        commit("SET_OPTIONS", staticOpts);
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
};